import React from "react"
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"
import styled from "styled-components"

const Champ = styled.span`
margin:10px;
padding:5px;
float:left;
display: inline-flex;
`
const Recherche = styled.div`
margin:10px;
padding: 5px;
width:100%
`

const ElementFormSearch = (params) => {

  const {typeElement, onSubmit} = params
  const initialValues = {
    critere: "",
    typeDocument: "undefined"
  }


  const validationSchema = Yup.object().shape({
    critere: Yup.string()
  })

  const afficheFacultatif = () => {
    switch(typeElement){
      case "document":
        return (
          <Champ>
            <label>Type de document</label>
            <Field name="typeDocument" as="select" className="form-control">
                <option value="undefined">Tous</option>
                <option value="estampage">Estampage</option>
                <option value="calque">Calque</option>
                <option value="dessin">Dessin</option>
                <option value="diapositive">Diapositive</option>
                <option value="fiche">Fiche</option>
                <option value="negatif">Négatif</option>
                <option value="plaque_verre">Plaque de verre</option>
                <option value="carnet">Carnet</option>
                <option value="photo">Tirage photo</option>
             </Field>
          </Champ>
        )
      default:
        return
    }
  }

  const FormulaireJSX = () => {
      return(
        <Recherche>
        <Form>
          <Champ>
            <label>Critere</label>
            <Field name="critere" type="text" className="form-control" size="40"/>
          </Champ>
          {afficheFacultatif()}
          <Champ><button type="submit" onSubmit={onSubmit}>Rechercher</button></Champ>
        </Form>
        </Recherche>
        )
  }

  return (<Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize={true}>
    <FormulaireJSX/>
  </Formik>)
}
export default ElementFormSearch